import api from 'services/api';

// Função auxiliar para obter o token de autenticação
const getAuthToken = () => {
  return localStorage.getItem('token'); // Aqui você pode trocar para outro método de armazenamento
};

const authService = {
  login: async (email, password) => {
    try {
      const response = await api.post(`/login`, {
        email,
        password,
      });
      // Salva o token após o login bem-sucedido
      const token = response.data.token;
      if (token) {
        localStorage.setItem('token', token); // Armazena o token
      }
      return response; 
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      throw error;
    }
  },

  getProfile: async () => {
    try {
      const token = getAuthToken(); // Obtém o token
      if (!token) {
        throw new Error('Usuário não autenticado');
      }

      // Adiciona o token no cabeçalho da requisição
      const response = await api.get(`/admin/user/perfil`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // Retorna os dados do perfil
    } catch (error) {
      console.error('Erro ao buscar perfil do usuário:', error);
      throw error;
    }
  },

  updateProfile: async (profileData) => {
    try {
      const token = getAuthToken(); // Obtém o token
      if (!token) {
        throw new Error('Usuário não autenticado');
      }

      // Adiciona o token no cabeçalho da requisição
      const response = await api.put(`/admin/user/perfil`, profileData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar perfil:', error);
      throw error;
    }
  },

  updatePassword: async (passwordData) => {
    try {
      const token = getAuthToken(); // Obtém o token
      if (!token) {
        throw new Error('Usuário não autenticado');
      }

      // Adiciona o token no cabeçalho da requisição
      const response = await api.post(`/admin/user/password`, passwordData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar senha:', error);
      throw error;
    }
  },

  logout: () => {
    // Remove o token de autenticação
    localStorage.removeItem('token'); // Supondo que você esteja usando localStorage para armazenar o token
    localStorage.removeItem('user'); // Remove outros dados relacionados ao usuário

    // Outras ações de logout podem ser adicionadas aqui, como limpar o contexto global
  },
};

export default authService;
